import PropTypes from 'prop-types';
import React from 'react';

import TalentTraits from 'shared/talentTraits';

import { Tooltip } from 'rebass';

const baseUrl = 'https://www.raidbots.com/static/images/TalentFrame/orig/elements';

const HeroTreeIcon = ({ subTreeId, selected, size, ...props }) => {
  const subtree = TalentTraits.getSubTreeById(subTreeId);
  if (!subtree) {
    return null;
  }
  // do a bunch of heuristic math to get the selection ring to always fit
  const iconSize = 200;
  const ringSize = 248;
  const mult = 1.22;
  const ringRatio = mult * (ringSize / iconSize);
  const offset = ((ringSize - iconSize + 34) / 2) * (size / iconSize) * mult;
  let ringImage = 'talents-heroclass-ring-selectionpane-gray.png';
  if (selected) {
    ringImage = 'talents-heroclass-ring-selectionpane-yellow.png';
  }
  return (
    <Tooltip title={subtree.name}>
      <div style={{ position: 'relative' }}>
        <img
          src={`${baseUrl}/${subtree.atlasMemberName}.png`}
          width={size}
          height={size}
          alt={subtree.name}
          {...props}
        />
        <img
          src={`${baseUrl}/${ringImage}`}
          width={size * ringRatio}
          height={size * ringRatio}
          alt=""
          {...props}
          style={{
            position: 'absolute',
            left: -offset,
            top: -offset,
            ...props?.style,
          }}
        />
      </div>
    </Tooltip>
  );
};

HeroTreeIcon.propTypes = {
  subTreeId: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  style: PropTypes.object,
};

HeroTreeIcon.defaultProps = {
  selected: false,
  style: {},
};

export default HeroTreeIcon;
